import map from "ramda/src/map";
import * as ActionTypes from "services/state/action-types";

const TECHNICIAN_INITIAL_STATE = {
  isModalOpen: false,
  clientLocale: null,
  technicians: [],
  emptyCoordinates: false,
};

export function technician(state = TECHNICIAN_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_TECHNICIAN:
      const { isModalOpen } = action.payload;
      const openModal = isModalOpen ? { isModalOpen } : {};
      return { ...state, loading: true, ...openModal };

    case ActionTypes.FOLLOW_TECHNICIAN_MODAL_STATE:
      return { ...state, isModalOpen: action.payload };

    case ActionTypes.SET_CLIENT_PRODUT_LOCALE:
      return { ...state, clientLocale: action.payload };

    case ActionTypes.GET_TECHNICIAN_SUCCESS:
      const { coordinates } = action.payload;
      const emptyCoordinates = !coordinates;
      const technicians = coordinates
        ? mapCoordinates([action.payload.coordinates])
        : [];
      return { ...state, technicians, emptyCoordinates };

    case ActionTypes.RESET_TECHNICIANS:
      return { ...state, technicians: [] };

    default:
      return state;
  }
}

const mapCoordinates = map(({ latitude, longitude }) => ({
  lat: latitude,
  lng: longitude,
}));



// WEBPACK FOOTER //
// ./src/services/state/technician/reducer.js